import React, { memo } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'

import CheckboxStyled from 'components/CommonUI/Checkbox'

const formContolStyle = makeStyles({
  label: {
    fontFamily: 'Source Sans Pro',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#151F31',
  },
})

const WeatherControl = ({ handleClickWeather, checked, disabled }) => {
  const classes = formContolStyle()
  return (
    <FormControlLabel
      value="bottom"
      onChange={handleClickWeather}
      control={<CheckboxStyled color="#4AA652" />}
      label={'Weather \u00B0C'}
      labelPlacement="end"
      checked={checked}
      disabled={disabled}
      classes={classes}
    />
  )
}

export default memo(WeatherControl)
